import { fetcher } from '@commenda/utils';

import { TIndirectTaxProduct, UpdateIndirectTaxProductProps } from './types';

type ProductResult = {
  success: boolean;
  data?: TIndirectTaxProduct;
  error?: string;
};

export async function updateIndirectTaxProduct(
  body: UpdateIndirectTaxProductProps,
  productId: string,
  corporationId: number,
  token?: string
): Promise<ProductResult> {
  try {
    const response = await fetcher(
      `new-sales-tax/products/${productId}/corporation/${corporationId}`,
      { method: 'POST', body },
      token
    );

    if (!response.ok) {
      const errorData = await response.json();
      return {
        success: false,
        error: errorData.message || 'Failed to update product',
      };
    }

    const data = await response.json();
    return { success: true, data };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Failed to update product';
    return { success: false, error: errorMessage };
  }
}
